export default "__VITE_ASSET__DvJmztex__"